import ButtonIconH from "./ButtonIconH";
import moment from "moment";
import "../css/GlassesHistoryBox.css";
import { formatValueUnit } from "../js/utils";

export default function HearingAidsHistoryBox({ data, onOpen }) {
  return (
    <div className="history-box">
      <div className="history-box-header">
        <div
          className="history-box-header-fields"
          style={{
            padding: "0px 20px",
            height: "30px",
          }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Fecha</span>
            <span>{moment(data.fecha).format("DD/MM/YYYY HH:mm:ss")}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Realizada por</span>
            <span>{data.empleado}</span>
          </div>
        </div>
        <div style={{ padding: "5px" }}>
          <ButtonIconH text="Mostrar" small onClick={onOpen}></ButtonIconH>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">
        Audífono derecho
      </span>
      <div className="history-box-content">
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.datosAudifonoD.proveedor || "-"}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.datosAudifonoD.codigo || "-"}</span>
            <span className="history-box-tag">Nº serie</span>
            <span>{data.datosAudifonoD.nSerie || "-"}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.datosAudifonoD.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Marca</span>
            <span>{data.datosAudifonoD.marca || "-"}</span>
            <span className="history-box-tag">Modelo</span>
            <span>{data.datosAudifonoD.modelo || "-"}</span>
            <span className="history-box-tag">Tipo</span>
            <span>{data.datosAudifonoD.tipo || "-"}</span>
            <span className="history-box-tag">Rango dB</span>
            <span>
              {(data.datosAudifonoD.entreDb || "-") +
                " - " +
                (data.datosAudifonoD.hastaDb || "-")}
            </span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Auricular</span>
            <span>{data.datosAudifonoD.auricular || "-"}</span>
            <span className="history-box-tag">Cód. auricular</span>
            <span>{data.datosAudifonoD.codigoAuricular || "-"}</span>
            <span className="history-box-tag">Pila</span>
            <span>{data.datosAudifonoD.pila || "-"}</span>
            <span className="history-box-tag">Cód. pila</span>
            <span>{data.datosAudifonoD.codigoPila || "-"}</span>
          </div>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">
        Audífono izquierdo
      </span>
      <div className="history-box-content">
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.datosAudifonoI.proveedor || "-"}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.datosAudifonoI.codigo || "-"}</span>
            <span className="history-box-tag">Nº serie</span>
            <span>{data.datosAudifonoI.nSerie || "-"}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.datosAudifonoI.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Marca</span>
            <span>{data.datosAudifonoI.marca || "-"}</span>
            <span className="history-box-tag">Modelo</span>
            <span>{data.datosAudifonoI.modelo || "-"}</span>
            <span className="history-box-tag">Tipo</span>
            <span>{data.datosAudifonoI.tipo || "-"}</span>
            <span className="history-box-tag">Rango dB</span>
            <span>
              {(data.datosAudifonoI.entreDb || "-") +
                " - " +
                (data.datosAudifonoI.hastaDb || "-")}
            </span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Auricular</span>
            <span>{data.datosAudifonoI.auricular || "-"}</span>
            <span className="history-box-tag">Cód. auricular</span>
            <span>{data.datosAudifonoI.codigoAuricular || "-"}</span>
            <span className="history-box-tag">Pila</span>
            <span>{data.datosAudifonoI.pila || "-"}</span>
            <span className="history-box-tag">Cód. pila</span>
            <span>{data.datosAudifonoI.codigoPila || "-"}</span>
          </div>
        </div>
      </div>
      <span className="history-box-tag history-box-title-bg">Cargador</span>
      <div className="history-box-content">
        <div
          className="history-box-header-fields"
          style={{ backgroundColor: "#f9f9f9" }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Proveedor</span>
            <span>{data.cargador.proveedor || "-"}</span>
            <span className="history-box-tag">Código</span>
            <span>{data.cargador.codigo || "-"}</span>
            <span className="history-box-tag">Marca</span>
            <span>{data.cargador.marca || "-"}</span>
            <span className="history-box-tag">Modelo</span>
            <span>{data.cargador.modelo || "-"}</span>
          </div>
          <div className="history-box-header-field">
            <span className="history-box-tag">Total</span>
            <span>{formatValueUnit(data.cargador.total, "€")}</span>
          </div>
        </div>
        <div
          className="history-box-header-fields"
          style={{
            padding: "0px 20px",
            height: "30px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <div className="history-box-header-field">
            <span className="history-box-tag">Total ficha</span>
            <span>{formatValueUnit(data.totalFicha, "€")}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
